import DataTable from 'datatables.net-bs5';
import language from 'datatables.net-plugins/i18n/pl.js';
import * as Spinner from "./spinner-tools";

Spinner.init();

// language.paginate.first = '<<';
// language.paginate.last = '>>';
// language.paginate.previous = '<';
// language.paginate.next = '>';

let InvoicesDataTables = new DataTable('.invoices-table', {
    language: language,
    select: {
        className: 'form-select'
    },
    columns: [
        {data: 'id'},
        {data: 'clientId'},
        {data: 'fvId'},
        {data: 'type'},
        {data: 'createDate'},
        {data: 'paymentDate'},
        {data: 'afterPaymentDate'},
        {data: 'status'},
        {data: 'nettoPrice'},
        {data: 'bruttoPrice'},
        {data: 'vat'},
        {data: 'toPay'},
        {data: 'toPayPln'},
        {data: 'mpp'},
    ],
    ajax: {
        url: '/moje-konto/faktury/pobierz',
        type: 'POST',
        data: {}
    },
    initComplete: function () {
        InvoicesDataTables.columns().flatten().each(function (colIdx) {
            if (colIdx === 2) {
                createSelect(InvoicesDataTables.column(colIdx));
            }
            if (colIdx === 4) {
                createSelect(InvoicesDataTables.column(colIdx));
            }
            if (colIdx === 5) {
                createSelect(InvoicesDataTables.column(colIdx));
            }
        });
    },
});
let createSelect = function(column) {
    let select = $('<select><option value="">' + $(column.header()).html() + '</option></select>')
        .addClass('form-select')
        .appendTo(
            column.footer()
        )
        .on('change', function () {
            column
                .search($(this).val())
                .draw();
        });
    column
        .data()
        .unique()
        .sort()
        .each(function (d) {
            select.append($('<option value="' + d + '">' + d + '</option>'));
        });
}


export {
    InvoicesDataTables
}
